module.exports = __webpack_public_path__ + "static/media/bonusBG.8d8ef608.svg";